import config from '../../config';
import { getApiAxiosInstance } from '../utils/network';

export const validateEmailConfirmation = async (memberId, tokenValue) => {
    const axiosInstance = getApiAxiosInstance();
    const url = `${config.apiHost}/v1/member/${memberId}/confirmemail?token=${tokenValue}`;
    try {
        const data = await axiosInstance.post(url);
        return data;
    } catch (error) {
        return error.response.data;
    }
};

export const resendEmailConfirmation = () => {
    const axiosInstance = getApiAxiosInstance();
    const url = `v1/member/resendconfirmemail`;
    const data = axiosInstance.post(url);
    return data;
};
